import { render, staticRenderFns } from "./UploadGenerateCertificatedModal.vue?vue&type=template&id=38601b4a&scoped=true&"
import script from "./UploadGenerateCertificatedModal.vue?vue&type=script&lang=js&"
export * from "./UploadGenerateCertificatedModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadGenerateCertificatedModal.vue?vue&type=style&index=0&id=38601b4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38601b4a",
  null
  
)

export default component.exports